module.exports = __webpack_public_path__ + "img/pleat depth.625afd20.png";